import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { formatMoneyPl } from '../../utils/currency';
import { localeForLanguage } from '../../utils/numberFormatting';

const { Text } = Typography;

interface TransportAllocatedCostProps {
  allocatedTransportCost?: number | null;
  originalCurrency?: string | null;
  originalAmount?: number | null;
  exchangeRateUsed?: number | null;
  provenanceClassName?: string;
}

/** Canonical PLN first; optional provenance comes only from the saved Cost snapshot. */
export const TransportAllocatedCost: React.FC<TransportAllocatedCostProps> = ({
  allocatedTransportCost,
  originalCurrency,
  originalAmount,
  exchangeRateUsed,
  provenanceClassName,
}) => {
  const { t, i18n } = useTranslation(['transport']);
  const normalizedCurrency = String(originalCurrency || '').toUpperCase();
  const hasSavedForeignProvenance = normalizedCurrency !== ''
    && normalizedCurrency !== 'PLN'
    && originalAmount != null
    && Number.isFinite(Number(originalAmount))
    && exchangeRateUsed != null
    && Number.isFinite(Number(exchangeRateUsed))
    && Number(exchangeRateUsed) > 0;
  const formattedRate = hasSavedForeignProvenance
    ? Number(exchangeRateUsed).toLocaleString(localeForLanguage(i18n.language), {
        minimumFractionDigits: 4,
        maximumFractionDigits: 6,
      })
    : null;

  return (
    <span data-testid="transport-allocated-cost">
      {formatMoneyPl(Number(allocatedTransportCost || 0), 'PLN')}
      {hasSavedForeignProvenance ? (
        <Text type="secondary" className={provenanceClassName} style={{ marginLeft: 6 }}>
          ({t('transport:allocation.costProvenance', {
            original: formatMoneyPl(Number(originalAmount), normalizedCurrency),
            rate: formattedRate,
          })})
        </Text>
      ) : null}
    </span>
  );
};
